<kendo-grid
    kendoGridSelectBy="attachment"
    [data]="attachmentFiles"
    [selectable]="{ mode: 'single' }"
    [pageable]="false"
    [loading]="refreshing"
    [groupable]="false"
    [reorderable]="true"
    [resizable]="true"
    [columnMenu]="{ filter: false }"
    style="height: 100%">
    <ng-template kendoGridToolbarTemplate>
        <kendo-buttongroup>
            <button
                kendoButton
                type="button"
                themeColor="info"
                [disabled]="!attachmentFiles || attachmentFiles.length === 0"
                title="{{ 'labels.refresh' | translate }}"
                (click)="refreshFiles()">
                <kendo-svg-icon [icon]="arrowRotateCwIcon"></kendo-svg-icon>
                {{ 'labels.refresh' | translate }}
            </button>
        </kendo-buttongroup>
    </ng-template>
    <kendo-grid-column
        [width]="50"
        headerClass="k-text-center"
        class="k-text-center"
        title="{{ 'grid.columns.actions' | translate }}"
        [filterable]="false"
        [groupable]="false"
        [includeInChooser]="false"
        [sortable]="false"
        [resizable]="true"
        [editable]="false"
        [reorderable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
            <kendo-buttongroup>
                <button
                    kendoButton
                    type="button"
                    fillMode="outline"
                    themeColor="info"
                    title="{{ 'labels.download' | translate }}"
                    (click)="downloadFile(dataItem)">
                    <kendo-svg-icon [icon]="downloadIcon"></kendo-svg-icon>
                </button>
            </kendo-buttongroup>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="attachment.fileName"
        [width]="200"
        headerClass="k-text-center"
        class="k-text-left"
        title="{{ 'cf-document.tab.files.column.fileName' | translate }}">
    </kendo-grid-column>
    <kendo-grid-column
        field="attachment.extension"
        [width]="100"
        headerClass="k-text-center"
        class="k-text-center"
        title="{{ 'cf-document.tab.files.column.extension' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
            <span class="badge badge-expired">
                {{ dataItem.attachment.extension }}
            </span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="createdAt"
        [width]="100"
        headerClass="k-text-center"
        class="k-text-right"
        title="{{ 'grid.columns.createdAt' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
            <span>
                {{ dataItem.createdAt | date: 'dd-MM-yyyy HH:mm' }}
            </span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="createdBy"
        [width]="200"
        headerClass="k-text-center"
        class="k-text-left"
        title="{{ 'grid.columns.createdBy' | translate }}">
    </kendo-grid-column>
</kendo-grid>
